import script from "./Task.vue?vue&type=script&setup=true&lang=js"
export * from "./Task.vue?vue&type=script&setup=true&lang=js"

import "./Task.vue?vue&type=style&index=0&id=a0106566&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0106566"]])

export default __exports__